import { TFunction } from 'i18next'
import { toast } from 'react-toastify'
import { HouseConsignmentFormSaveResult } from './useHouseConsignmentForm'

// eslint-disable-next-line import/prefer-default-export
export function notifyHouseConsignmentSaveResult(
  result: HouseConsignmentFormSaveResult | null,
  t: TFunction,
) {
  if (!result) return

  if (!result.success) {
    toast.error(result.errorReason === 'validation'
      ? String(t('houseConsignment.validationError'))
      : String(t('houseConsignment.saveError')))
  } else {
    toast.success(String(t('houseConsignment.saveSuccess')))
  }
}
